import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/ar-images/icon/xnszr-icon.png'
import _imports_1 from '@/assets/images/ar-images/icon/dzfa-icon.png'


const _hoisted_1 = { class: "metaverse" }
const _hoisted_2 = { class: "yycj" }
const _hoisted_3 = { class: "yycj-content" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "content-title" }
const _hoisted_7 = { class: "wmdys" }
const _hoisted_8 = { class: "wmdys-content" }
const _hoisted_9 = { class: "wmdys-content-top" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "content" }

import SubTitle from '@/components/SubTitle.vue';
import { modelTypes } from '@/config';
import ExampleIntroduction from '@/components/common/ExampleIntroduction.vue';
import StepProcess from '@/components/common/StepProcess.vue';
import { exampleDatas } from '@/config/index';
import store from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'MetaverseView',
  setup(__props) {

const gntxData = [
  {
    title: '打破时空限制',
    content: '观众可以随时随地通过虚拟身份进入展厅，不受时间和空间的限制。',
    url: require('@/assets/images/ar-images/icon/skxz-icon.png')
  },
  {
    title: '降低展览成本',
    content: '相比传统展览，元宇宙展厅无需额外租赁实体场地、布置展品等，可以大大降低展览成本。',
    url: require('@/assets/images/ar-images/icon/jdcb-icon.png')
  },
  {
    title: '提升观众体验',
    content: '通过虚拟现实和增强现实技术，元宇宙展厅可以为观众提供更加真实、沉浸式的观展体验和互动体验。',
    url: require('@/assets/images/ar-images/icon/tsty-icon.png')
  }
]

const handleEvent = () => {
  let contactUsTop: any = store.state.contactUsTop;
  contactUsTop = {
    bottom: 457 + 'rem'
  }
  store.state.contactUsTop = JSON.parse(JSON.stringify(contactUsTop))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SubTitle, { "title-text": "应用场景" }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("main", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelTypes)['metaverse'], (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: item.header
            }, [
              _createElementVNode("img", {
                src: item.image,
                alt: ""
              }, null, 8, _hoisted_4),
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.remarkList[0]), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.header), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(SubTitle, {
        "mode-class": "black-style",
        "title-text": "我们的优势"
      }),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(gntxData, (item, index) => {
            return _createElementVNode("div", { key: index }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: item.url,
                  class: "l-iamge",
                  alt: ""
                }, null, 8, _hoisted_11),
                _createElementVNode("div", null, _toDisplayString(item.title), 1)
              ]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.content), 1)
            ])
          }), 64))
        ]),
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"wmdys-content-bottom\" data-v-1a22c604><div class=\"left\" data-v-1a22c604><header data-v-1a22c604><img src=\"" + _imports_0 + "\" class=\"l-iamge\" alt=\"\" data-v-1a22c604><div class=\"r-head\" data-v-1a22c604>AI虚拟数字人</div></header><div class=\"line\" data-v-1a22c604>通过虚拟数字人导游为观众提供一对一游览引导、产品讲解和互动答疑服务。数字人形象、声音、交互动作均可定制。</div></div><div class=\"right\" data-v-1a22c604><header data-v-1a22c604><img src=\"" + _imports_1 + "\" class=\"l-iamge\" alt=\"\" data-v-1a22c604><div class=\"r-head\" data-v-1a22c604>VR/AR等多种技术方案</div></header><div class=\"line\" data-v-1a22c604>既可以采用VR全景展厅的方式，也可以采用AR增强现实的方式部署虚实互动的展厅。多种方式均可定制。</div></div></div>", 1))
      ])
    ]),
    _createVNode(ExampleIntroduction, {
      exampleData: _unref(exampleDatas).yyzzt
    }, null, 8, ["exampleData"]),
    _createVNode(StepProcess, {
      "step-title": ['一站式开发流程'],
      "step-type": "step2"
    }),
    _createElementVNode("div", { class: "counselling-btn" }, [
      _createElementVNode("div", {
        class: "btn",
        onClick: handleEvent
      }, "合作咨询")
    ])
  ]))
}
}

})